// 兼容旧版 hash 链接：/#/orders?a=1 → /orders?a=1
// 必须在 router 模块求值之前执行（main.js 中第一个 import），
// 否则 createWebHistory 会按当前 hash URL 解析出错误路由。
if (window.location.hash.startsWith('#/')) {
  window.location.replace(window.location.hash.slice(1))
}
